var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'WorkOrder', params: { woId: _vm.data.id }}}},[_c('span',[_vm._v(_vm._s(_vm.data.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }